import { Button, Chip, Fab, Grid } from "@mui/material";
import Templete from "../../template/Template";
import { MouseEvent, useEffect, useState } from "react";
import { api } from "../../services/api";
import SimpleBackdrop from "../../components/Loading/SimpleBackdrop";
import { Link, useNavigate } from "react-router-dom";
import CardSimple from "../../components/Cards/CardSimple";
import { endMes, formatDate, startMes } from "../../utilities/date";
import { AlertConfirm, AlertInfo } from "../../components/Alerts/Alert";
import { ProcessoType } from "../../types/ProcessoType";
import IconMenu from "../../components/Menu/IconMenu";
import EditIcon from '@mui/icons-material/Edit';
import DescriptionIcon from '@mui/icons-material/Description';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import SensorOccupiedIcon from '@mui/icons-material/SensorOccupied';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CheckIcon from '@mui/icons-material/Check';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import OutlinedFlagIcon from '@mui/icons-material/OutlinedFlag';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import PriceCheckIcon from '@mui/icons-material/PriceCheck';
import SearchIcon from '@mui/icons-material/Search';
import AssuredWorkloadIcon from '@mui/icons-material/AssuredWorkload';
import EditNoteIcon from '@mui/icons-material/EditNote';
import HistoricoProcesso from "../../modals/processos/HistoricoProcesso";
import ObservacoesProcesso from "../../modals/processos/ObservacoesProcesso";
import SearchProcessos from "./SearchProcessos";
import moment from "moment";
import { isPermite } from "../../utilities/isPermite";
import TableData from "../../components/Tables/TableData";
import { GridColDef } from "@mui/x-data-grid";
import Recibo from "../../modals/Recibo/Recibo";

export default function Processos() {
    const navigate = useNavigate();
    const [activeProcess, setActiveProcess] = useState<null | ProcessoType>(null);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [anchorElD, setAnchorElD] = useState<null | HTMLElement | MouseEvent<Element | EventTarget> >(null);
    const [anchorElRPV, setAnchorElRPV] = useState<null | HTMLElement | MouseEvent<Element | EventTarget> >(null);
    const [openLoad, setOpenLoad] = useState(false);
    const [openSearch, setOpenSearch] = useState(false);
    const [openHistroy, setOpenHistory] = useState(false);
    const [openModalRecibo, setOpenModalRecibo] = useState(false);
    const [openModalObs, setOpenModalObs] = useState(false);
    const [arrHistory, setArrHistory] = useState([]);
    const [allRows, setAllRows] = useState([]);
    const [rows, setRows] = useState([]);
    const [labelFilter, setLabelFilter] = useState("");
    const [counts, setCounts] = useState({
        cancelados: 0, preparacao: 0, andamento: 0, concluidos: 0
    });
    const columns: GridColDef[] = [
        {
            field: 'corretor_responsavel',
            headerName: 'PARCEIRO',
            width: 160,
        },
        {
            field: 'protocolo_processo',
            headerName: 'NUMERO PROCESSO',
            width: 220,
        },
        {
            field: 'nome_cliente',
            headerName: 'NOME',
            width: 320,
        },
        {
            field: 'causa_processual',
            headerName: 'CAUSA',
            width: 200,
        },
        {
            field: 'status_processo',
            headerName: 'STATUS',
            width: 200,
        },
        {
            field: 'create_processo',
            headerName: 'DATA CADASTRO',
            width: 140,
            valueFormatter: (dt: any) => formatDate(dt, "brH")
        },
    ];

    function editProcess() {
        if (activeProcess) {
            if (isPermite("32")) {
                navigate(`/cadastroprocesso?id=${activeProcess.id_processo}`);
            }
        }
    }

    function openDocument() {
        if (activeProcess) {
            setOpenLoad(true);
            setAnchorEl(null);
            api.get(`/createpeticao/${activeProcess.id_processo}`, { responseType: 'blob' }).then(response => {
                console.log(response);
                if (response.status === 204) {
                    return AlertInfo({ icon: 'error', title: "Documento não localizado" }).then(() => setOpenLoad(false));
                }
                const url = window.URL.createObjectURL(response.data);
                const link = document.createElement('a');
                link.href = url;
                link.download = `${activeProcess.causa_processual} - ${activeProcess.nome_cliente}.docx`;
                link.click();
                window.URL.revokeObjectURL(url);
                setOpenLoad(false);
            });
        }
    }

    function openDocumentRequired(fileDoc: string, nameDoc: string, isComplement = false) {
        if (activeProcess) {
            setOpenLoad(true);
            setAnchorEl(null);
            setAnchorElD(null);
            setAnchorElRPV(null);
            let docFile = fileDoc;
            if(isComplement){
                if(activeProcess.is_analfabeto) docFile+= '_analfabeto';
                else if(activeProcess.is_incapaz) docFile+= '_incapaz';
            }
            console.log(docFile);
            api.get(`/documentrequerid/${docFile}/${activeProcess.id_processo}`, { responseType: 'blob' }).then(response => {
                if (response.status === 204) {
                    return AlertInfo({ icon: 'error', title: "Documento não localizado" }).then(() => setOpenLoad(false));
                }
                const url = window.URL.createObjectURL(response.data);
                const link = document.createElement('a');
                link.href = url;
                link.download = `${nameDoc} - ${activeProcess.nome_cliente}.docx`;
                link.click();
                window.URL.revokeObjectURL(url);
                setOpenLoad(false);
            });
        }
    }
    
    function openDocumentRecurso() {
        if (activeProcess) {
            const recurso = activeProcess.tipo_recurso;
            if(recurso.length === 0) return AlertInfo({icon:'info', title: 'Tipo Recurso não Selecionado'})
            const docFile = `${activeProcess.name_document}_${recurso}`;
            console.log(docFile);
            openDocumentRequired(encodeURI(`${docFile}`), `${activeProcess.causa_processual} ${recurso}`);
        }
    }

    async function openHistoryStatus() {
        if (activeProcess) {
            setOpenLoad(true);
            setAnchorEl(null);
            setAnchorElD(null);
            setAnchorElRPV(null);
            try {
                const response = await api.get(`/eventosproceso/${activeProcess.id_processo}`);
                if (response.status === 200 && response.data) {
                    if (response.data.error) {
                        AlertInfo({ icon: 'error', title: response.data.message });
                    } else {
                        setArrHistory(response.data);
                        setOpenHistory(true);
                    }
                }
            } catch (error) {
                console.log(error);
                AlertInfo({ icon: 'error', title: 'Falha na conexão' });
            }
            setOpenLoad(false);
        }
    }

    function deleteProcess() {
        setAnchorEl(null);
        setAnchorElD(null);
        if(isPermite("33")){
            const text = 'Após deleta-lo ele não aparecerá nos registro de busca';
            AlertConfirm({ icon: 'info', title: 'Deletar Processo?', text }).then(async res => {
                if (res.isConfirmed) {
                    setOpenLoad(true);
                    try {
                        const data = {
                            id_processo: activeProcess?.id_processo,
                            processo_ativo: 0,
                            delete_processo: moment().format("YYYY-MM-DD HH:mm:ss"),
                        };
                        const response = await api.post(`/updateprocesso`, data);
                        if (response && response.status === 200 && response.data) {
                            if (response.data.success) {
                                AlertInfo({ icon: 'success', title: 'PROCESSO DELETADO' }).then(() => {
                                    loadData();
                                });
                            } else if (response.data.error) {
                                AlertInfo({ icon: 'error', title: response.data.message })
                            }
                        }
                    } catch (error) {
                        console.log(error);
                        AlertInfo({ icon: 'error', title: 'Falha na conexão' });
                    }
                    setOpenLoad(false);
                }
            });
        }else{
            AlertInfo({ icon: 'info', title: 'Usuario sem permissão' });            
        }
    }

    function openObsProcess() {
        if(activeProcess){
            setOpenModalObs(true);
        }
    }

    const arrMenu = [
        { icon: <EditIcon fontSize="small" color="primary" />, title: "Editar Processo", handle: editProcess },
        { icon: <DescriptionIcon fontSize="small" color="primary" />, title: "Gerar Petição", handle: openDocument },
        
        { icon: <OutlinedFlagIcon fontSize="small" color="primary" />, title: "Atendimento Inicial", handle: () => openDocumentRequired('atendimento_inicial', 'Atendimento Inicial', true) },
        { icon: <RadioButtonCheckedIcon fontSize="small" color="primary" />, title: "Gerar Recurso/Resposta", handle: () => openDocumentRecurso() },
        { icon: <ChevronRightIcon fontSize="small" color="primary" />, title: "Procuração", handle: () => openDocumentRequired('procuracao', "Procuração", true) },
        { icon: <CheckIcon fontSize="small" color="primary" />, title: "Declarações", handle: (event: MouseEvent<HTMLElement>) => setAnchorElD(event.currentTarget) },
        { icon: <CheckCircleIcon fontSize="small" color="primary" />, title: "Contrato INSS", handle: () => openDocumentRequired('contrato_inss', "Contrato INSS", true) },
        { icon: <SensorOccupiedIcon fontSize="small" color="primary" />, title: "Termo de Responsabilidade", handle: () => openDocumentRequired('termo_responsabilidade', "Termo de Responsabilidade") },
        { icon: <AssuredWorkloadIcon fontSize="small" color="primary" />, title: "Documentos RPV - BB", handle: (event: MouseEvent<HTMLElement>) => setAnchorElRPV(event.currentTarget) },
        
        { icon: <PriceCheckIcon fontSize="small" color="primary" />, title: "Gerar Recibo", handle: () => setOpenModalRecibo(true) },
        { icon: <AccessTimeIcon fontSize="small" color="primary" />, title: "Historico de Status", handle: openHistoryStatus },
        { icon: <EditNoteIcon fontSize="small" color="primary" />, title: "Observações Processuais", handle: openObsProcess },
        { icon: <DeleteForeverIcon fontSize="small" color="primary" />, title: "Deletar Processo", handle: deleteProcess }
    ];

    const arrSubMenuDeclacao = [
        { icon: <CheckIcon fontSize="small" color="primary" />, title: "Declaração de Hipossuficiência", handle: () => openDocumentRequired('contrato_hipossuficiencia', "Declaração de Hipossuficiência", true) },
        { icon: <CheckIcon fontSize="small" color="primary" />, title: "Declaração de Autenticidade", handle: () => openDocumentRequired('declaracao_autenticidade', "Declaração de Autenticidade", true) },
        { icon: <CheckIcon fontSize="small" color="primary" />, title: "Declaração de Entidade Conveniada", handle: () => openDocumentRequired('declaracao_entidadde_conveniada', "Declaração de Entidade Conveniada", true) },
    ];
    
    const arrSubMenuRPV = [
        { icon: <AssuredWorkloadIcon fontSize="small" color="primary" />, title: "Declaração de Isenção IR", handle: () => openDocumentRequired('declaracao_isencao_rpv', "Declaração de Isenção IR", true) },
        { icon: <AssuredWorkloadIcon fontSize="small" color="primary" />, title: "Formulário Banco do Brasil", handle: () => openDocumentRequired('formulario_banco_brasil', "Formulário Banco do Brasil", true) },
        { icon: <AssuredWorkloadIcon fontSize="small" color="primary" />, title: "Procuração para RPV", handle: () => openDocumentRequired('procuracao_rpv', "Procuração para RPV", true) },
    ];


    function handleClick(process: ProcessoType, event: any) {
        setActiveProcess(process);
        setAnchorEl(event.currentTarget);
    }

    async function handleProcess(search: string) {
        setOpenLoad(true);
        let res = [];
        try {
            const response = await api.post(`/processos_clientes`, {nome_cliente: search});
            console.log(response);
            if (response && response.status === 200 && response.data) {
                if (response.data.error) {
                    AlertInfo({ icon: 'error', title: response.data.message });
                }else{
                    const arr = response.data;
                    res = arr.map((item: ProcessoType, index: number) => ({id: index, ...item}));
                }
            }
        } catch (error) {
            console.log(error);
            AlertInfo({ icon: 'error', title: 'Falha na Conexão' });
        }
        setOpenLoad(false);
        return res;
    }

    async function loadData() {
        setOpenLoad(true);
        try {
            const response = await api.post(`/processos`);
            if (response && response.status === 200 && response.data) {
                if (response.data.error) {
                    AlertInfo({ icon: 'error', title: response.data.message });
                } else {
                    const arr = response.data;
                    const data = arr.map((item: ProcessoType, index: number) => ({id: index, ...item}));
                    setAllRows(data);
                }
                setLabelFilter(`${formatDate(startMes(), "br")} à ${formatDate(endMes(), 'br')}`);
            }
        } catch (error) {
            console.log(error);
            AlertInfo({ icon: 'error', title: 'Falha na Conexão' });
        }
        setOpenLoad(false);
    }

    function filterProcess(cod: number) {
        const filter = allRows.filter((i: ProcessoType) => i.codigo_status_processo === cod);
        setRows(filter);
    }

    useEffect(() => {
        const cancelados = allRows.filter((i: ProcessoType) => i.codigo_status_processo === 1).length;
        const preparacao = allRows.filter((i: ProcessoType) => i.codigo_status_processo === 2).length;
        const andamento = allRows.filter((i: ProcessoType) => i.codigo_status_processo === 3).length;
        const concluidos = allRows.filter((i: ProcessoType) => i.codigo_status_processo === 4).length;
        setCounts({ cancelados, preparacao, andamento, concluidos });
        setRows(allRows);
    }, [allRows]);

    useEffect(() => {
        loadData();
    }, []);

    return (
        <Templete menuActive="processos">
            <Grid container spacing={1}>
                <Grid item xs={12} sm={2}>
                    {isPermite("31") && (
                        <Link to="/cadastroprocesso">
                            <Button
                                variant="contained"
                                fullWidth
                            >
                                NOVO PROCESSO
                            </Button>
                        </Link>
                    )}
                </Grid>
                <Grid item xs={false} sm={6}></Grid>
                <Grid item xs={12} sm={4} justifyContent="flex-end" container alignItems="center">
                    <Chip label={labelFilter} variant="outlined" onDelete={loadData} />
                    <Fab size="medium" color="primary" aria-label="search" onClick={() => setOpenSearch(true)} >
                        <SearchIcon />
                    </Fab>
                </Grid>
                <Grid item xs={12}></Grid>
                <Grid item xs={12} sm={3}>
                    <CardSimple
                        title="CANCELADOS"
                        txt={counts.cancelados}
                        color="bgError"
                        handle={() => filterProcess(1)}
                    />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <CardSimple
                        title="EM PREPARAÇÃO"
                        txt={counts.preparacao}
                        color="bgPrimary"
                        handle={() => filterProcess(2)}
                    />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <CardSimple
                        title="EM ANDAMENTO"
                        txt={counts.andamento}
                        color="bgBlue"
                        handle={() => filterProcess(3)}
                    />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <CardSimple
                        title="CONCLUIDOS"
                        txt={counts.concluidos}
                        color="bgSuccess"
                        handle={() => filterProcess(4)}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TableData
                        columns={columns}
                        rows={rows}
                        height={420}
                        handleClick={handleClick}
                        filter="nome_cliente"
                        title="PROCESSOS"
                        filterOut={handleProcess}
                    />
                    <IconMenu
                        anchorEl={anchorEl}
                        setAnchorEl={setAnchorEl}
                        arrMenu={arrMenu}
                    />
                    <IconMenu
                        anchorEl={anchorElD}
                        setAnchorEl={setAnchorElD}
                        arrMenu={arrSubMenuDeclacao}
                        subMenu
                    />
                    <IconMenu
                        anchorEl={anchorElRPV}
                        setAnchorEl={setAnchorElRPV}
                        arrMenu={arrSubMenuRPV}
                        subMenu
                    />
                </Grid>

                <SimpleBackdrop open={openLoad} />
                <HistoricoProcesso
                    open={openHistroy}
                    setOpen={setOpenHistory}
                    historico={arrHistory}
                />
                <SearchProcessos
                    open={openSearch}
                    setOpen={setOpenSearch}
                    setAllRows={setAllRows}
                    setLabelFilter={setLabelFilter}
                />
                <Recibo
                    open={openModalRecibo}
                    setOpen={setOpenModalRecibo}
                    activeProcess={activeProcess}
                />
                <ObservacoesProcesso
                    open={openModalObs}
                    setOpen={setOpenModalObs}
                    activeProcess={activeProcess}
                    onSaved={loadData}
                />
            </Grid>
        </Templete>
    );
}